var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"流标处理"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.auctionInfo,"option":_vm.actionOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }},scopedSlots:_vm._u([{key:"closeAttachmentIds",fn:function(){return [_c('upload',{ref:"uploadFile",attrs:{"file-id-before":_vm.auctionInfo.closeAttachmentIds,"props-data":{
                limit: 10,
                disabled: true,
                uploadMode: 'fileId',
                singleUpload: false
              }},on:{"update:fileIdBefore":function($event){return _vm.$set(_vm.auctionInfo, "closeAttachmentIds", $event)},"update:file-id-before":function($event){return _vm.$set(_vm.auctionInfo, "closeAttachmentIds", $event)}}})]},proxy:true},{key:"content",fn:function(){return [_c('u-editor',{attrs:{"disabled":"","value":_vm.auctionInfo.content}})]},proxy:true}])})],1)])]),(
      _vm.auctionInfo.closeType === _vm.negotiationV2AuctionStatusDict.RESTART.value
    )?_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"免收平台使用费"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.auctionInfo,"option":_vm.feeOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('u-editor',{attrs:{"disabled":"","value":_vm.auctionInfo.content}})]},proxy:true}],null,false,3983863483)})],1)])]):_vm._e(),_c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"流标公告"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.auctionInfo,"option":_vm.noticeOptions,"el-attrs":{
            size: 'medium',
            column: 1,
            labelStyle: {
              width: '140px',
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('u-editor',{attrs:{"disabled":"","value":_vm.auctionInfo.content}})]},proxy:true}])})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }